// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M10.8 12L14.7 15.9Q14.98 16.18 14.98 16.6T14.7 17.3 14 17.58 13.3 17.3L8.7 12.7Q8.55 12.55 8.49 12.37T8.43 12 8.49 11.62 8.7 11.29L13.3 6.69Q13.58 6.41 14 6.41T14.7 6.69 14.98 7.39 14.7 8.09Z"/>';

/** Chevron Left (arrows). */
const icon: IconData = {
  id: "chevron-left",
  name: "Chevron Left",
  category: "arrows",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: '<path d="M14 18L8 12 14 6 15.4 7.4 10.8 12 15.4 16.6Z"/>' },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M10.8 12L14.7 15.9Q14.98 16.18 14.98 16.6T14.7 17.3 14 17.58 13.3 17.3L8.7 12.7Q8.55 12.55 8.49 12.37T8.43 12 8.49 11.62 8.7 11.29L13.3 6.69Q13.58 6.41 14 6.41T14.7 6.69 14.98 7.39 14.7 8.09Z"/></g><path d="M10.8 12L14.7 15.9Q14.98 16.18 14.98 16.6T14.7 17.3 14 17.58 13.3 17.3L8.7 12.7Q8.55 12.55 8.49 12.37T8.43 12 8.49 11.62 8.7 11.29L13.3 6.69Q13.58 6.41 14 6.41T14.7 6.69 14.98 7.39 14.7 8.09Z"/>',
    },
  },
  animation: () => import("../animations/chevron-left.js"),
};

export default icon;
